import React, { Component, Fragment } from "react";
import RcTooltip from "rc-tooltip";
import Classnames from "classnames";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import Voca from "voca";
import Store from "@/stores";

import { LINK, MAP_HERO_EN_CN, MAP_SLOT_EN_CN } from "@/utils/getting";

class EquipTips extends Component {
	static propTypes = {
		accountBound: PropTypes.bool,
		armor: PropTypes.number,
		attributesHtml: PropTypes.object,
		displayColor: PropTypes.string,
		dps: PropTypes.string,
		flavorText: PropTypes.string,
		gems: PropTypes.array,
		hero_class: PropTypes.string,
		icon: PropTypes.string,
		isHover: PropTypes.bool,
		name: PropTypes.string,
		requiredLevel: PropTypes.number,
		set: PropTypes.object,
		slots: PropTypes.string,
		typeName: PropTypes.string
	}
	static defaultProps = {
		accountBound: false,
		armor: 0,
		attributesHtml: {},
		displayColor: "white",
		dps: "",
		flavorText: "",
		gems: [],
		hero_class: "",
		icon: "",
		isHover: true,
		name: "",
		requiredLevel: 0,
		set: {},
		slots: "",
		typeName: ""
	}
	render() {
		const { accountBound, attributesHtml, armor, displayColor, dps, flavorText, gems, hero_class: hero, icon, isHover, name, requiredLevel, set, slots, typeName } = this.props;
		const { primary, secondary } = attributesHtml;
		if (!isHover) return <p className="tips">系统繁忙，请稍后再试...</p>;
		const value = armor ? Math.round(armor) : dps || 0;
		const primaryList = primary
			? primary.map((v, i) => <p key={i} dangerouslySetInnerHTML={{ __html: v }} />)
			: null;
		const secondaryList = secondary
			? secondary.map((v, i) => <p key={i} className={v.includes("tooltip-icon") ? "property" : ""} dangerouslySetInnerHTML={{ __html: v }} />)
			: null;
		const gemList = gems.length
			? gems.map((v, i) => {
				return v.isGem
					? (
						<p key={i} className="gem">
							{v.item && <img src={`${LINK.gem}/${v.item.icon}.png`} />}
							<i />
							{v.attributes}
						</p>
					)
					: (
						<p key={i} className="jewelry">
							<span>
								{v.item && <img src={`${LINK.gem}/${v.item.icon}.png`} />}
								{v.item && v.item.name}
								<em>-等级{v.jewelRank}</em>
							</span>
							<span><i />{v.attributes}</span>
						</p>
					);
			})
			: null;
		return (
			<Fragment>
				<h3 className={displayColor}>{name}</h3>
				<div className="title pr">
					<div className={`avatar pa ${displayColor}`}>
						<img className="abs-ct" src={`${LINK.equip}/${icon}.png`} />
					</div>
					<h4 className={displayColor}>{typeName}</h4>
					{value && <h5>{value}</h5>}
					{value && <h6>{armor ? "护甲" : dps ? "每秒伤害" : ""}</h6>}
					<p className="fr">
						{MAP_SLOT_EN_CN[slots]}
						<span>{MAP_HERO_EN_CN[hero]}</span>
					</p>
				</div>
				<div className="desc">
					<h4>主要属性</h4>
					{primaryList}
				</div>
				<div className="desc">
					<h4>次要属性</h4>
					{secondaryList}
					{gemList}
				</div>
				<div className="suit" dangerouslySetInnerHTML={{ __html: set ? set.descriptionHtml : "" }} />
				<div className="remark">
					<p>需要等级：<span>{requiredLevel}</span></p>
					{accountBound && <p>账号绑定</p>}
					{icon && icon.includes("unique") && <p>仅可装备一件</p>}
				</div>
				<p className="summary">{flavorText}</p>
			</Fragment>
		);
	}
}

class EquipItem extends Component {
	static propTypes = {
		displayColor: PropTypes.string,
		gems: PropTypes.array,
		icon: PropTypes.string,
		name: PropTypes.string,
		slots: PropTypes.string,
		twoHandedClass: PropTypes.bool
	}
	static defaultProps = {
		displayColor: "white",
		gems: [],
		icon: "",
		name: "",
		slots: "",
		twoHandedClass: false
	}
	render() {
		const { displayColor, gems, icon, name, slots, twoHandedClass } = this.props;
		const list = gems.length
			? gems.map((v, i) => v.item && <li key={i}><img src={`${LINK.gem}/${v.item.icon}.png`} /></li>)
			: null;
		return (
			<RcTooltip
				destroyTooltipOnHide={true}
				overlay={<EquipTips {...this.props} />}
				overlayClassName="ladder-equip-tips"
				placement="rightTop"
			>
				<div className={Classnames(`ladder-equip-item ${Voca.kebabCase(slots)} ${displayColor}`, { twoHanded: twoHandedClass })}>
					<img className="abs-ct" src={`${LINK.equip}/${icon}.png`} />
					<p>{name}</p>
					<ul className="abs-ct">{list}</ul>
				</div>
			</RcTooltip>
		);
	}
}

@observer
class Equip extends Component {
	render() {
		const { class: classes, gender, items, level, name, paragonLevel } = Store._ladderStore.hero;
		const hero = classes + (gender === 1 ? "-w" : "-m");
		const list = Object.keys(items).sort().map(v => {
			console.log(v);
			return <EquipItem key={v} {...Object.assign({}, items[v], { slots: items[v].slots ? items[v].slots : v })} />;
		});
		return (
			<div className={`ladder-equip ${hero} pr`}>
				<small>{level}<span>({paragonLevel})</span>{MAP_HERO_EN_CN[classes]}</small>
				<h3>{name}</h3>
				{list}
			</div>
		);
	}
}
export default Equip;